import { ProjectCallsInsightType, ScriptBlockKind, ScriptBlockSource } from "@prisma/client";
import { Limits } from "@/app/vars/Limits";

export enum StandardScriptBlock {
  OPENING = "OPENING",
  QUESTIONS = "QUESTIONS",
  OBJECTIONS = "OBJECTIONS",
  NEXT_STEP = "NEXT_STEP",
}

export type StandardScriptBlockShape = {
  type: StandardScriptBlock;
  kind: ScriptBlockKind;
  source: ScriptBlockSource | null;
  suggestion: ScriptBlockSource | null;
  hasResponse: boolean;
  isFilterable: boolean;
  isOrdered: boolean;
  maxItems: number;
};

export const STANDARD_SCRIPT_BLOCKS: StandardScriptBlockShape[] = [
  {
    type: StandardScriptBlock.OPENING,
    kind: ScriptBlockKind.TEXT,
    source: null,
    suggestion: null,
    hasResponse: false,
    isFilterable: false,
    isOrdered: false,
    maxItems: 0,
  },
  {
    type: StandardScriptBlock.QUESTIONS,
    kind: ScriptBlockKind.LIST,
    source: null,
    suggestion: ScriptBlockSource.PAIN_POINT,
    hasResponse: false,
    isFilterable: false,
    isOrdered: true,
    maxItems: Limits.MAX_SCRIPT_QUESTIONS,
  },
  {
    type: StandardScriptBlock.OBJECTIONS,
    kind: ScriptBlockKind.LIST,
    source: ScriptBlockSource.OBJECTION,
    suggestion: null,
    hasResponse: true,
    isFilterable: true,
    isOrdered: false,
    maxItems: Limits.MAX_SCRIPT_OBJECTIONS,
  },
  {
    type: StandardScriptBlock.NEXT_STEP,
    kind: ScriptBlockKind.TEXT,
    source: null,
    suggestion: null,
    hasResponse: false,
    isFilterable: false,
    isOrdered: false,
    maxItems: 0,
  },
];

export const INSIGHT_TYPE_BY_SOURCE: Record<ScriptBlockSource, ProjectCallsInsightType> = {
  [ScriptBlockSource.PAIN_POINT]: ProjectCallsInsightType.PAIN_POINT,
  [ScriptBlockSource.OBJECTION]: ProjectCallsInsightType.OBJECTION,
};

export const SCRIPT_STEPS: StandardScriptBlock[][] = [
  [StandardScriptBlock.OPENING],
  [StandardScriptBlock.QUESTIONS, StandardScriptBlock.OBJECTIONS],
  [StandardScriptBlock.NEXT_STEP],
];
